import React from "react";

function Canvas_Coordinates() {
  return (
    <div>
      <h1>Canvas_Coordinates Component</h1>
      <p>This is the Canvas Coordinates tutorial page content.</p>
    </div>
  );
}

export default Canvas_Coordinates;
